// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1scWp","left":"styles_left__vFM28","desktopActions":"styles_desktopActions__L5wgr","title":"styles_title__3iC3P"};